import Progress from "./Progress";
import H1 from "@/components/ui/H1";
import { Suspense } from "react";
import LoadingSection from "@/components/LoadingSection";

export default function TrackerPanel() {
  return (
    <div className="w-full max-w-4xl pl-2 pt-10 lg:pl-8 ">
      <H1 className="w-full pb-8">Tracker</H1>
      <Suspense fallback={<LoadingSection />}>
        <Progress />
      </Suspense>
    </div>
  );
}
